<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-02-02 16:30:27
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-02-02 18:05:20
 * @FilePath: \crm-product\found\views\mdm\views\feed_back\feedBack.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import request, { portUrl } from '@/found/utils/request';
import TablePage from '../../../../components/table_page';
import Form from './form';

export default {
  name: 'feedBack',
  extends: TablePage,
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  components: {
    Form,
  },

  methods: {
    clickVisible({ row, val: { code } }) {
      const { status } = row;
      if (status === 'reply' && code === 'reply') {
        return false;
      }
      return true;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      this.formConfig = {
        type: val.code,
        code: val.code,
        id: row.id || null,
      };
      if (val.code === 'reply') {
        this.modalConfig.title = '回复';
        this.modalConfig.width = '80%';
        this.openFull();
      } else if (val.code === 'view') {
        this.modalConfig.title = '查看';
        this.modalConfig.width = '80%';
        this.formConfig.buttonCode = 'view';
        this.openFull();
      }
    },
  },
  created() {
    // 重写获取配置信息
    this.getConfigList('main_list');
  },
};
</script>
